import React from 'react'
import TableHead from '@mui/material/TableHead'
import { TableCell, TableRow, TableSortLabel, Tooltip, useTheme } from '@mui/material'
import { Box } from '@mui/system'
import { HeadCell, Order } from '../../utils/tableFunctions'
import { visuallyHidden } from '@mui/utils'

interface EnhancedTableProps {
    onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void
    order: Order
    orderBy: string
    rowCount: number
    headCells: readonly HeadCell[]
}

const EnhancedTableHead = (props: EnhancedTableProps) => {
    const theme = useTheme()

    const { order, orderBy, onRequestSort, headCells } = props
    const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property)
    }

    return (
        <TableHead style={{ backgroundColor: theme.palette.tableHeader.default }}>
            <TableRow
                style={{
                    height: '42px',
                }}
            >
                {headCells.map((headCell) =>
                    headCell.id === 'buttons' ? (
                        <TableCell key={headCell.id} />
                    ) : (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align ? headCell.align : headCell.centered ? 'center' : 'left'}
                            padding='none'
                            sx={{
                                paddingLeft: headCell.disablePadding ? '0px' : headCell.align === 'right' ? '0px' : '14px',
                                paddingRight: headCell.disablePadding ? '0px' : headCell.align === 'right' ? '14px' : '0px'
                            }}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.component ? (
                                    <Tooltip title={headCell.label} placement='bottom-end' enterDelay={300}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>{headCell.component}</Box>
                                    </Tooltip>
                                ) : (
                                    headCell.label
                                )}
                                {orderBy === headCell.id ? (
                                    <Box component='span' style={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    )
                )}
            </TableRow>
        </TableHead>
    )
}

export default EnhancedTableHead
